import { post, get } from '@helpcenter/ajax';
import { contextPath } from '@atlassian/help-center-common-util/history';

export async function initialValidation(
    requestKey: string,
    token: string | undefined,
    rating?: number,
    context: string = contextPath
) {
    const ratingParam = rating ? `?rating=${rating}` : '';
    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const uri = `${context}/rest/servicedesk/1/customer/feedback/initial-validation/${requestKey}/${token}${ratingParam}`;
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    };
    return get(uri, headers).toPromise();
}

export const updateRating = async (
    portalId: number,
    requestKey: string,
    token: string | undefined,
    rating: number,
    context: string = contextPath
) => makePostRequest(portalId, requestKey, createBodyForRating(token, rating), context);

function makePostRequest(portalId: number, requestKey: string, body: string, context: string) {
    const uri = `${context}/rest/servicedesk/1/customer/feedback/portal/${portalId}/${requestKey}`;
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    };
    return post(uri, body, headers).toPromise();
}

const createBodyForRating = (tokenToUse?: string, ratingToUse?: number) =>
    JSON.stringify({
        token: tokenToUse,
        rating: ratingToUse,
    });

export const updateComment = async (
    portalId: number,
    requestKey: string,
    token: string | undefined,
    rating: number,
    comment: string,
    context: string = contextPath
) => makePostRequest(portalId, requestKey, createBodyForComment(token, rating, comment), context);

const createBodyForComment = (tokenToUse: string | undefined, ratingToUse: number, updatedComment: string) =>
    JSON.stringify({
        token: tokenToUse,
        rating: ratingToUse,
        comment: updatedComment,
    });
